import {Tab as MuiTab} from '@material-ui/core'

import {Tooltip, Chip} from '@material-ui/core'
import {TabProps} from '@material-ui/core/Tab';
import {TooltipProps} from '@material-ui/core/Tooltip/Tooltip'
import {LocationDescriptor} from 'history';
import * as React from 'react';

const Tab = MuiTab as React.ComponentType<TabProps & { to?: LocationDescriptor }>

export {Tab}

import * as css from './mui.css'
import _ from 'lodash'

_.merge(Chip, { defaultProps: { classes: { root: css.chip }}})


// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/mui.ts